import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_CREATE_REQUEST,
  CONFIDENTIAL_CREATE_SUCCESS,
  CONFIDENTIAL_CREATE_FAILURE,
  CONFIDENTIAL_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case CONFIDENTIAL_CREATE_SUCCESS:
      return state
        .set('confidentialCreate', fromJS(action.payload.createdEmployeeConfidential))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case CONFIDENTIAL_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('confidentialCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CONFIDENTIAL_CREATE_RESET:
      return state
        .delete('confidentialCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-create-reducer.js